//crear funciones de manejar toda la información del token
import { TOKEN } from "./contants";
import jwtDecode from "jwt-decode";
//pasamos el token y guardamos en local storage
export function setToken(token) {
  localStorage.setItem(TOKEN, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN);
}
export function setMenuBar(menu) {
  localStorage.setItem("MENU", menu);
}
export function getMenuBar() {
  return localStorage.getItem("MENU");
}

export function decodeToken(token) {
  return jwtDecode(token);
}

export function removeToken() {
  return localStorage.removeItem(TOKEN);
}

export function verifyToken() {
  let token = localStorage.getItem(TOKEN);
  //validamo si existe el token
  if (token) {
    const { exp } = jwtDecode(token);

    if (exp * 1000 < Date.now()) {
      localStorage.clear();
      return false;
    }
    return true;
  }
  return false;
}
